const visibleScroll = () => {
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
};

export default visibleScroll;



// WEBPACK FOOTER //
// ./scripts/modules/enable-scroll.js